import { PontemWallet } from '@pontem/wallet-adapter-plugin';
import { BitgetWallet } from '@bitget-wallet/aptos-wallet-adapter';
import { NightlyWallet } from '@nightlylabs/aptos-wallet-adapter-plugin';
import { FewchaWallet } from 'fewcha-plugin-wallet-adapter';
import { MartianWallet } from '@martianwallet/aptos-wallet-adapter';
import { MSafeWalletAdapter } from '@msafe/aptos-wallet-adapter';
import { TrustWallet } from '@trustwallet/aptos-wallet-adapter';
import { OKXWallet } from '@okwallet/aptos-wallet-adapter';
import { AvailableWallets, useWallet } from '@aptos-labs/wallet-adapter-vue';
import { ChainsEnum } from '@/constants/chains';
import { CORRECT_CHAIN } from '@/constants';
import { ref } from 'vue';

const movementSupportedWallets = [
  new PontemWallet(),
  new NightlyWallet(),
  new OKXWallet(),
  new MSafeWalletAdapter(),
];

const allWallets = [
  new PontemWallet(),
  new BitgetWallet(),
  new NightlyWallet(),
  new FewchaWallet(),
  new MartianWallet(),
  new MSafeWalletAdapter(),
  new TrustWallet(),
  new OKXWallet(),
];
const isMovementChain = [
  ChainsEnum['movement-testnet'],
  ChainsEnum['movement-mainnet'],
].includes(CORRECT_CHAIN.id);
const supportedWallets = isMovementChain
  ? movementSupportedWallets
  : allWallets;

const {
  connected,
  isLoading,
  account,
  network,
  wallet,
  wallets,
  autoConnect,
  connect,
  disconnect,
  signAndSubmitTransaction,
  signTransaction,
  submitTransaction,
  signMessage,
  signMessageAndVerify,
  changeNetwork,
} = useWallet({
  plugins: supportedWallets,
  optInWallets: isMovementChain
    ? ([
        'Nightly',
        'Pontem Wallet',
        'Leap Wallet',
        'OKX Wallet',
        'Razor Wallet',
        'MSafe',
      ] as AvailableWallets[])
    : undefined,
  onError: (error) => {
    console.log(error);
  },
});

export function useWalletPlugin(_autoConnect = true) {
  autoConnect.value = _autoConnect;
  return {
    connected,
    isLoading,
    account,
    network,
    wallet,
    wallets: isMovementChain
      ? ref(
          wallets?.value
            ?.filter((w) => w.name !== 'Petra')
            .sort((a, b) => {
              if (a.name === 'Nightly') return -1;
              if (b.name === 'Nightly') return 1;
              return 0;
            }),
        )
      : wallets,
    autoConnect,
    connect,
    disconnect,
    signAndSubmitTransaction,
    signTransaction,
    submitTransaction,
    signMessage,
    signMessageAndVerify,
    changeNetwork,
  };
}

export * from '@aptos-labs/wallet-adapter-vue';
